import * as React from "react";
import * as moment from "moment";
import { fullName } from "../../../../helperComponents";

var ModalUser = function ModalUser(_ref) {
  var _user$region, _user$city, _user$comuna;

  var user = _ref.user,
      open = _ref.open,
      onClose = _ref.onClose;

  var formatDate = function formatDate(date) {
    if (!date) return "-";
    return moment(date).format("DD/MM/YYYY");
  };

  var getPersonType = function getPersonType(user) {
    if (user.type === "Users::NaturalPerson") return "Persona Natural";
    if (user.type === "Users::LegalPerson") return "Persona Jurídica";
    return "Usuario";
  };

  var getAge = function getAge(birthdate) {
    if (!birthdate) return "-";
    var age = moment().diff(moment(birthdate), 'years');
    return "".concat(age, " a\xF1os");
  };

  if (!open) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-overlay",
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content",
    style: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '800px',
      maxHeight: '80vh',
      overflow: 'auto',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    style: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer'
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("h2", null, "Detalles del Usuario"), /*#__PURE__*/React.createElement("div", {
    className: "user-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("h4", null, "Informaci\xF3n B\xE1sica"), /*#__PURE__*/React.createElement("table", {
    className: "table table-striped"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "ID:")), /*#__PURE__*/React.createElement("td", null, user.id)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Nombre:")), /*#__PURE__*/React.createElement("td", null, fullName(user) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "RUT:")), /*#__PURE__*/React.createElement("td", null, user.rut || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Tipo:")), /*#__PURE__*/React.createElement("td", null, getPersonType(user))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Email:")), /*#__PURE__*/React.createElement("td", null, user.email || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Tel\xE9fono:")), /*#__PURE__*/React.createElement("td", null, user.phone || "-")), user.birthdate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Fecha de nacimiento:")), /*#__PURE__*/React.createElement("td", null, formatDate(user.birthdate))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Edad:")), /*#__PURE__*/React.createElement("td", null, getAge(user.birthdate))))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("h4", null, "Direcci\xF3n"), /*#__PURE__*/React.createElement("table", {
    className: "table table-striped"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Regi\xF3n:")), /*#__PURE__*/React.createElement("td", null, ((_user$region = user.region) === null || _user$region === void 0 ? void 0 : _user$region.name) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Ciudad:")), /*#__PURE__*/React.createElement("td", null, ((_user$city = user.city) === null || _user$city === void 0 ? void 0 : _user$city.name) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Comuna:")), /*#__PURE__*/React.createElement("td", null, ((_user$comuna = user.comuna) === null || _user$comuna === void 0 ? void 0 : _user$comuna.name) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Direcci\xF3n:")), /*#__PURE__*/React.createElement("td", null, user.street || "-")))))), user.emails && user.emails.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h4", null, "Emails"), /*#__PURE__*/React.createElement("table", {
    className: "table table-striped"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Principal"))), /*#__PURE__*/React.createElement("tbody", null, user.emails.map(function (email, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, email.email), /*#__PURE__*/React.createElement("td", null, email.is_main ? "Sí" : "No"));
  }))))), user.addresses && user.addresses.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h4", null, "Direcciones"), /*#__PURE__*/React.createElement("table", {
    className: "table table-striped"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Direcci\xF3n"), /*#__PURE__*/React.createElement("th", null, "Regi\xF3n"), /*#__PURE__*/React.createElement("th", null, "Comuna"), /*#__PURE__*/React.createElement("th", null, "Principal"))), /*#__PURE__*/React.createElement("tbody", null, user.addresses.map(function (address, index) {
    var _address$region, _address$comuna;

    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, address.street || "-"), /*#__PURE__*/React.createElement("td", null, ((_address$region = address.region) === null || _address$region === void 0 ? void 0 : _address$region.name) || "-"), /*#__PURE__*/React.createElement("td", null, ((_address$comuna = address.comuna) === null || _address$comuna === void 0 ? void 0 : _address$comuna.name) || "-"), /*#__PURE__*/React.createElement("td", null, address.is_main ? "Sí" : "No"));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h4", null, "Informaci\xF3n del Sistema"), /*#__PURE__*/React.createElement("table", {
    className: "table table-striped"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Creado:")), /*#__PURE__*/React.createElement("td", null, formatDate(user.created_at))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "Actualizado:")), /*#__PURE__*/React.createElement("td", null, formatDate(user.updated_at)))))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-actions mt-3"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary me-2",
    onClick: onClose
  }, "Cerrar"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary me-2",
    onClick: function onClick() {
      window.open("/users/".concat(user.id), "_blank");
      onClose();
    }
  }, "Ver Completo"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-outline-primary",
    onClick: function onClick() {
      window.open("/users/".concat(user.id, "/edit"), "_blank");
      onClose();
    }
  }, "Editar"))));
};

export default ModalUser;